var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from 'react';
import { SecondaryButton } from '@gjensidige/core-buttons';
import { Text, Title } from '@gjensidige/core-typography';
import { text } from '../../../../utils/text';
import { Action, Risikoprofil, RoutePath, Spareformål, } from '../../../../utils/types';
import { NavigationButtons } from '../../../common/NavigationButtons/NavigationButtons';
import { Card } from '../../../common/Card/Card';
import { Default as Alert } from '@gjensidige/core-alerts/lib/default';
import { Edit } from '@gjensidige/core-icons';
import utils from '@gjensidige/core-utilities-css';
import styles from './summary.module.less';
import { scenarioSteps, trackScenario } from '../../../../tracking';
import { Redirect, useHistory } from 'react-router-dom';
import { submitFormData, validateUttaksalder } from '../../../../utils/api';
import { Layout } from '../../../common/Layout/Layout';
import { useGlobalContext } from '../../../../context/GlobalContext';
import { useFormContext } from '../../../../context/FormContext';
import { getFormPayload, getProfilBeskrivelse, getProfilEnumName, getSpareformålSummary, hasAllCustomerData, } from '../../../../utils/utils';
import { Pill } from '@gjensidige/core-pill';
import { Spacer } from '../../../common/Spacer/Spacer';
import sizing from '../../../../utils/sizing.module.less';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Form } from '../../../common/Form/Form';
import { InputNumber } from '../../../common/Form/InputNumber';
import { InputGroupSimple } from '../../../common/Form/InputGroupSimple';
import { FeatureFlagsContext } from '../../../../AppWrapper';
export const Summary = () => {
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [{ sellerRef }, globalDispatch] = useGlobalContext();
    const [formState, dispatch] = useFormContext();
    const history = useHistory();
    const featureFlags = useContext(FeatureFlagsContext);
    const { kontoopplysninger, profildata, risikoanbefaling, porteføljedata, utbetalingsdetaljer } = formState;
    useEffect(() => {
        trackScenario(scenarioSteps.SUMMARY);
    }, []);
    const profil = (profildata === null || profildata === void 0 ? void 0 : profildata.profile) || (risikoanbefaling === null || risikoanbefaling === void 0 ? void 0 : risikoanbefaling.anbefaling.risikoprofil);
    const { handleSubmit, control, watch, setError } = useForm({
        resolver: yupResolver(uttaksalderBarnValidation),
        defaultValues: {
            isKnownPayoutAge: false,
        },
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
    });
    if (!profil || !porteføljedata || !kontoopplysninger.spareformål) {
        return React.createElement(Redirect, { to: RoutePath.KONTO });
    }
    const submitUttaksalder = (data) => {
        var _a;
        if (data.payoutAge !== undefined && kontoopplysninger.barnetsFnr) {
            setIsSubmitting(true);
            if (!((_a = featureFlags.featureFlags) === null || _a === void 0 ? void 0 : _a.opprettPrivatprodukterICoreSuite)) {
                validateUttaksalder({
                    barnetsAlderVedUttak: data.payoutAge,
                    barnetsFnr: kontoopplysninger.barnetsFnr,
                }).then((result) => {
                    if (result.isOk()) {
                        if (result.value.isValid) {
                            submitAvtale(data.payoutAge);
                        }
                        else {
                            setIsSubmitting(false);
                            setError('payoutAge', { message: result.value.errorMessage });
                        }
                    }
                    else {
                        setIsSubmitting(false);
                        setErrorMessage(text.FORM.SUMMARY.PAYOUT.VALIDATION_FAILED.no);
                    }
                });
            }
            else {
                submitAvtale(data.payoutAge);
            }
        }
    };
    const hasCustomerData = hasAllCustomerData(formState);
    const submitAvtale = (barnetsAlderVedUttak) => {
        if (!hasCustomerData) {
            dispatch({ type: Action.SUBMIT_CUSTOM_PAYOUT_AGE, barnetsAlderVedUttak });
            history.push(RoutePath.ABOUT);
        }
        else {
            setIsSubmitting(true);
            const data = getFormPayload(Object.assign(Object.assign({}, formState), { barnetsAlderVedUttak }), sellerRef, featureFlags);
            submitFormData(data).then((result) => {
                if (result.isOk()) {
                    const { requestId, signingUrl } = result.value;
                    globalDispatch({
                        type: Action.UPDATE_SIGNING_PARAMS,
                        signingParams: { requestId, signingUrl },
                    });
                    history.push(`/signing/${requestId}`);
                }
                else {
                    setErrorMessage('An unexpected error occured when retrieving signing status');
                }
                setIsSubmitting(false);
            });
        }
    };
    const isKnownPayoutAge = watch('isKnownPayoutAge').toString() === 'true';
    const edit = (path) => {
        history.push({ pathname: path, state: { isEdit: true } });
    };
    /**
     * Koordiner med MK-analyse om denne endres.
     */
    const trackingLabel = 'signert-avtale-fondskonto';
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no },
        React.createElement(Card, { step: 6, className: styles.summary },
            React.createElement(Form, { onSubmit: handleSubmit(submitUttaksalder) },
                React.createElement(KontonavnSection, { kontoopplysninger: kontoopplysninger, edit: edit }),
                React.createElement("hr", null),
                React.createElement(SpareformålSection, { "spareform\u00E5l": kontoopplysninger.spareformål, edit: edit }),
                React.createElement("hr", null),
                React.createElement(FondsvalgSection, { profil: profil, "portef\u00F8ljedata": porteføljedata, risikoanbefaling: risikoanbefaling, edit: edit }),
                React.createElement("hr", null),
                React.createElement(UtbetalingSection, { isKnownPayoutAge: isKnownPayoutAge, utbetalingsdetaljer: utbetalingsdetaljer, "spareform\u00E5l": kontoopplysninger.spareformål, profil: profil, control: control }),
                errorMessage && (React.createElement(Alert, { alertType: "error", title: text.DOCUMENT_SIGNED_PAGE.ERROR.HEADER.no, text: errorMessage })),
                React.createElement(NavigationButtons, { isSubmit: isKnownPayoutAge, onNext: !isKnownPayoutAge ? () => submitAvtale() : undefined, onPrevious: () => history.push(RoutePath.RAADGIVNING_FATCA), nextText: hasCustomerData ? text.NAV_BUTTONS.SUBMIT.no : text.NAV_BUTTONS.NEXT.no, loading: isSubmitting, trackingEventlabel: trackingLabel })))));
};
const KontonavnSection = ({ kontoopplysninger, edit, }) => {
    return (React.createElement("div", { className: styles.summaryTitle },
        React.createElement(Title, { tag: 'h2', size: 'h4' }, text.FORM.SUMMARY.TITLE.no),
        React.createElement("div", { className: styles.editRow },
            React.createElement(Title, { tag: 'h3', size: 'h3' }, kontoopplysninger.kontonavn || text.FORM.SUMMARY.KONTONAVN.DEFAULT_KONTONAVN.no),
            React.createElement(SecondaryButton, { onClick: () => edit(RoutePath.KONTO), noPadding: true, icon: React.createElement(Edit, null) }, text.FORM.SUMMARY.KONTONAVN.CHANGE.no))));
};
const SpareformålSection = ({ spareformål, edit }) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.editRow },
            React.createElement(Title, { tag: "h3", size: "h4" }, text.FORM.SUMMARY.SPAREFORMÅL.TITLE.no),
            React.createElement(SecondaryButton, { onClick: () => edit(RoutePath.KONTO), noPadding: true, icon: React.createElement(Edit, null) }, text.FORM.SUMMARY.SPAREFORMÅL.CHANGE_SPAREFORMÅL.no)),
        React.createElement(Text, null, getSpareformålSummary(spareformål))));
};
const FondsvalgSection = ({ profil, risikoanbefaling, porteføljedata, edit }) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.editRow },
            React.createElement(Title, { tag: "h3", size: "h4" }, text.FORM.SUMMARY.FONDSVALG.TITLE.no),
            React.createElement(SecondaryButton, { onClick: () => edit(RoutePath.PROFIL), noPadding: true, icon: React.createElement(Edit, null) }, text.FORM.SUMMARY.FONDSVALG.CHANGE.no)),
        React.createElement("div", { className: styles.profilPillRow },
            React.createElement(Text, null, getProfilEnumName(profil)),
            (risikoanbefaling === null || risikoanbefaling === void 0 ? void 0 : risikoanbefaling.anbefaling.risikoprofil) === profil && (React.createElement(Pill, { className: styles.pill, color: 'green' }, text.FORM.PROFILE_FORM.ANBEFALT_PROFIL_PILL.no))),
        React.createElement(Text, { size: 'small', secondary: true }, getProfilBeskrivelse(profil, porteføljedata))));
};
const UtbetalingSection = (_a) => {
    var { utbetalingsdetaljer, spareformål, profil } = _a, sectionBarnProps = __rest(_a, ["utbetalingsdetaljer", "spareform\u00E5l", "profil"]);
    switch (spareformål) {
        case Spareformål.PENSJON:
            return (React.createElement("div", null,
                React.createElement(Title, { tag: "h3", size: "h4" }, text.FORM.SUMMARY.PAYOUT.TITLE.no),
                React.createElement(Text, { className: utils['mb-1'] }, text.FORM.SUMMARY.PAYOUT.CONTENT.PAYOUT_AGE(utbetalingsdetaljer.uttaksalder).no),
                profil !== Risikoprofil.TRYGG && React.createElement(Text, null, text.FORM.SUMMARY.PAYOUT.CONTENT.STEP_DOWN.no)));
        case Spareformål.BARN_BARNEBARN:
            return React.createElement(UtbetalingSectionBarn, Object.assign({}, sectionBarnProps));
        case Spareformål.SPESIFIKT_MÅL:
        case Spareformål.IKKE_SPESIFIKT_MÅL:
            return null;
    }
};
const UtbetalingSectionBarn = ({ control, isKnownPayoutAge }) => {
    return (React.createElement(Spacer, { child: 'sm' },
        React.createElement(Title, { tag: "h3", size: "h4" }, text.FORM.SUMMARY.PAYOUT.SPAREFORMÅL_BARN.TITLE.no),
        React.createElement(Text, { className: utils['mb-1'] }, text.FORM.SUMMARY.PAYOUT.SPAREFORMÅL_BARN.CONTENT.no),
        React.createElement(InputGroupSimple, { name: "isKnownPayoutAge", id: "isKnownPayoutAge", type: "radio", options: [
                { label: 'Vet ikke', value: 'false' },
                { label: 'Ja', value: 'true' },
            ], control: control, centered: false }),
        isKnownPayoutAge && (React.createElement(InputNumber, { id: 'payoutAge', name: 'payoutAge', labelText: 'Barnets alder ved utbetaling', postfixText: 'år', inputWrapperClassName: sizing.mw160, control: control }))));
};
const uttaksalderBarnValidation = yup.object().shape({
    isKnownPayoutAge: yup.boolean(),
    payoutAge: yup.number().when('isKnownPayoutAge', {
        is: (value) => value,
        then: yup.number().required('Du må fylle ut barnets alder ved utbetalingsstart.'),
    }),
});
